export default __webpack_public_path__ + "images/manage-accounts.svg";